import { AnyAction } from 'redux'

import config from '@/config'
import { Auth0Config } from '@/types'
import { UPDATE_AUTH0_CONFIG, RESET_AUTH0_CONFIG } from './constants'

const { auth0 } = config
const auth0Config = auth0 as Auth0Config

const initialState: Auth0Config = {
  ...auth0Config,
}

export default (state = { ...initialState }, { type, payload }: AnyAction) => {
  switch (type) {
    case RESET_AUTH0_CONFIG:
      return {
        ...initialState,
      }
    case UPDATE_AUTH0_CONFIG:
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
